import { z } from 'zod'

export const paramsSchema = z.object({
  page: z.number().int().optional(),
  limit: z.number().int().optional(),
  l: z.string().optional(),
  f: z.string().optional(),
  min_price: z.number().optional(),
  max_price: z.number().optional(),
  d: z.string().optional(), // Date range in format: "date_in,date_out"
  c: z.number().int().optional(),
  a: z.number().int().optional(),
  cor: z.number().int().optional(),
  ec: z.number().int().optional(),
  r: z.string().optional(),
  bo: z.number().int().optional(),
  sort: z.string().optional(),
  q: z.string().optional(),
})

export type paramsType = z.infer<typeof paramsSchema>
